import { render } from "./submittedDetail.vue?vue&type=template&id=28501eaf"
import script from "./submittedDetail.vue?vue&type=script&lang=js"
export * from "./submittedDetail.vue?vue&type=script&lang=js"

import "./submittedDetail.vue?vue&type=style&index=0&id=28501eaf&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__